export default {
    //child:{name:"ExportSelected"}

    items: [
        {
            id:"btnDownloadZip",
            type: "button",
            text: "Download Zip",
            icon:"file-zip",
            showIcon: "toolbar",
            attributes: { "class": " btn btn-secondary float-right-btn" }
        },
        {
            id:"btnBulkDelete",
            type: "button",
            text: "Bulk Delete",
            icon:"delete",
            showIcon: "toolbar",
            attributes: { "class": " btn btn-danger float-right-btn" }
        }
    ]
}